/*
 * @Author: 邓彬强 7386652+dengbinqiang@user.noreply.gitee.com
 * @Date: 2025-02-08 01:44:46
 * @LastEditors: 邓彬强 7386652+dengbinqiang@user.noreply.gitee.com
 * @LastEditTime: 2025-04-18 23:11:25
 * @FilePath: \zhulianpcweb\src\api\common.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 公共js
 * */
import request from "@/request";

// 获取logo
export const GetLogo = () => request.get('/api/index/loginDisplayImage')

// 发送手机验证码
export const SetMobileCode = data => request.post('/api/sms/send', data)

// 企业类别
export const GetCompanyTypeList = () => request.get('/api/company_type/list')

// 企业性质
export const GetCompanyBusinessList = () => request.get('/api/business_type/treeList')

// 登录、注册页展示图
export const GetLoginBanner = () => request.get('/api/index/loginDisplayImage')

// 所在地区
export const GetAllArea = () => request.get('/api/area/treeList')

// 涉及领域
export const GetFieldList = () => request.get('/api/domain/treeList')

// 覆盖品类
export const GetCategoryList = () => request.get('/api/coverage_category/treeList')

// 企业树形结构
export const GetCompanyTree = () => request.get('/api/company_type/treeList')

// 获取协议

export const GetSystemArticleData = data => request.get('/api/common/getSystemArticle', data)

//记录查看申请日志
export const applyDetail = data => request.get('/api/inventory_resources/applyDetail', data)